var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("timeline-item-card", {
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function () {
          return _vm._l(_vm.applications, function (ref, index) {
            var applicationId = ref.applicationId
            var propertyAddress = ref.propertyAddress
            var mortgageAmount = ref.mortgageAmount
            var filogixId = ref.filogixId
            var co_applicants = ref.co_applicants
            return _c(
              "b-row",
              {
                key: applicationId,
                staticClass: "py-1",
                class: !_vm.last(index) ? "mb-2 pb-2" : "",
              },
              [
                _c("b-col", { attrs: { cols: "12" } }, [
                  _c(
                    "p",
                    {
                      staticClass: "bold mb-0",
                      class: {
                        "text-primary": _vm.isLinkApplication,
                        "text-danger": !_vm.isLinkApplication,
                        small: _vm.smallText,
                      },
                    },
                    [
                      _c("span", [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("application.applicationID")) +
                            ": " +
                            _vm._s(applicationId) +
                            "\n            "
                        ),
                        filogixId
                          ? _c("span", { staticClass: "ml-1" }, [
                              _vm._v("(" + _vm._s(filogixId) + ")"),
                            ])
                          : _vm._e(),
                      ]),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("b-col", { attrs: { cols: "12" } }, [
                  _c(
                    "p",
                    { staticClass: "small text-gray mb-0 regular-line-height" },
                    [
                      _c("span", { staticClass: "bold" }, [
                        _vm._v(
                          _vm._s(_vm.$tc("global.words.address", 1)) + ":"
                        ),
                      ]),
                      _vm._v(
                        "\n          " + _vm._s(propertyAddress) + "\n        "
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("b-col", { attrs: { cols: "12" } }, [
                  _c(
                    "p",
                    { staticClass: "small text-gray mb-0 regular-line-height" },
                    [
                      _c("span", { staticClass: "bold" }, [
                        _vm._v(
                          _vm._s(_vm.$t("global.doorr.mortgageAmount")) + ":"
                        ),
                      ]),
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.formatMoneyValue(mortgageAmount)) +
                          "\n        "
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _c("b-col", { attrs: { cols: "12" } }, [
                  _c(
                    "p",
                    { staticClass: "small text-gray mb-0 regular-line-height" },
                    [
                      _c("span", { staticClass: "bold" }, [
                        _vm._v(_vm._s(_vm.$t("application.coapps")) + ":"),
                      ]),
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.coappsString(co_applicants)) +
                          "\n        "
                      ),
                    ]
                  ),
                ]),
              ],
              1
            )
          })
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            _c(
              "b-row",
              {
                staticClass: "justify-content-between align-items-center",
                attrs: { "no-gutters": "" },
              },
              [
                _c("i18n", {
                  staticClass: "mb-0",
                  attrs: { path: _vm.linkAppMessage, tag: "p" },
                  scopedSlots: _vm._u([
                    {
                      key: "name",
                      fn: function () {
                        return [
                          _c("span", [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.getChangelogName(_vm.userDetails)) +
                                "\n          "
                            ),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "action",
                      fn: function () {
                        return [
                          _c("span", { staticClass: "bold" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.linkApplicationAction) +
                                "\n          "
                            ),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                }),
                _vm._v(" "),
                _c("p", { staticClass: "tiny-f mb-0" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm._f("formatDateHour")(_vm.insertionTimestamp)) +
                      "\n      "
                  ),
                ]),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }